import DOMPurify from 'dompurify'

export function sanitizeHtml<D>(data: D): D {
  if (typeof data === 'string') {
    return DOMPurify.sanitize(data, { ADD_ATTR: ['target'] }) as D
  }
  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      data[index] = sanitizeHtml(item)
    })
  }
  if (data?.constructor === Object) {
    const dataObject = data as Record<string | number, unknown>
    Object.keys(dataObject).forEach((key) => {
      dataObject[key] = sanitizeHtml(dataObject[key])
    })
  }

  return data
}
